import useUserPermission from "~/hooks/useUserPermission";
import { ADMIN_PROJECTS } from "~/router/permissions";

// The `admin:projects` functional scope bypasses the per-object FGA axis on the
// backend (see `authorize_capability`), so an admin can list and manage every
// project regardless of their resolved access level. Gates the admin "All
// projects" view. The scope is unprovisioned today, so this reads false for
// everyone until it's granted.
export const useCanAdministerProjects = (): boolean => useUserPermission(ADMIN_PROJECTS);
